import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class S3UploaderView extends Backbone.View
  FILE_SIZE_MAX_IN_BYTES = 5368709120 # 5 gigabytes
  VALID_PICKER_INPUTS = ["s3-uploader", "asset_uploader_input"]

  events:
    "s3_upload_complete"            : "s3UploadComplete"
    "s3_uploads_start"              : "s3UploadStart"
    "s3_upload_failed"              : "s3UploadFailed"
    "fileuploaddrop"                : "onFileUploadDrop"

  initialize: (options) ->
    @setParentResourceTypeAndId(options)
    @dispatcher = BackboneDispatcher.get_instance()
    @s3uploader = $("#s3-uploader").S3Uploader(
      progress_bar_target: $(".s3-upload-progress-wrapper")
      remove_completed_progress_bar: @assetableType != "MediaLibrary"
      before_add: @verifyFileSizeAndFormat
    )

    @externalProcessing = false
    @dispatcher.bind("setParentResourceOptions", @setParentResourceOptions)
    @dispatcher.bind("setUploadButton", @setUploadButton)

  verifyFileSizeAndFormat: (file) =>
    # File size check
    if file.size > FILE_SIZE_MAX_IN_BYTES
      contently.flash.alert("The file size must be less than 5GB.")
      return false

    # File type check
    acceptedFormats = $("#asset_uploader_input").attr("accept")
    if !!acceptedFormats && acceptedFormats.indexOf(file.type) == -1
      contently.flash.alert("The file type is not supported.")
      return false

    true

  setParentResourceTypeAndId: (uploaderOptions) ->
    @assetableId         = uploaderOptions.assetableId
    @assetableType       = uploaderOptions.assetableType
    @assetType           = uploaderOptions.assetType || "standard"
    @initialResourceId   = @assetableId
    @isRequirementsAsset = @assetType == "requirement"
    @relationship        = uploaderOptions.relationship || "assets"

  setParentResourceOptions: (uploaderOptions) =>
    @externalProcessing = uploaderOptions.externalProcessing || false
    @setParentResourceTypeAndId(uploaderOptions)
    @s3uploader.additional_data(uploaderOptions)
    @moveProgressBar()

  onFileUploadDrop: (event, data) ->
    # Return if drag&drop was meant for another uploader
    $dropZone = $("#asset-picker-modal .modal-content-wrapper .dropzone")
    if $dropZone.exists()
      pickerForAttr = $dropZone.attr("for")
      return false if !~VALID_PICKER_INPUTS.indexOf(pickerForAttr)

    isEditor = event.target.className.match /redactor-editor/
    editorParents = $(event.target).parents(".redactor-editor")

    if isEditor || editorParents.length > 0
      event.preventDefault()

  moveProgressBar: () ->
    unless @assetableType == "Field" || @isRequirementsAsset
      progressBar = $(".s3-upload-progress-wrapper")
      progressBar.detach()
      $("#asset-progress").append progressBar

  setUploadButton: (button) =>
    @$uploadButton = $(button)

  s3UploadFailed: (e, upload) ->
    console.error("[S3Upload] Upload failed:", { fileName: upload?.filename, fileType: upload?.filetype, fileSize: upload?.filesize, assetableType: @assetableType, assetableId: @assetableId })
    contently.flash.alert("Upload failed. This may be caused by browser security settings. Please check your browser's tracking prevention settings or contact your IT team.")
    if window.datadogRum?
      window.datadogRum.addError(new Error("S3 direct upload failed"), {
        fileName: upload?.filename,
        fileType: upload?.filetype,
        fileSize: upload?.filesize,
        assetableType: @assetableType,
        assetableId: @assetableId,
      })

  s3UploadComplete: (e, upload) ->
    # unescape "/" so paperclip knows which part is the filename
    upload.url = upload.url.replace(/%2F/g, "/")

    if @assetableType == "MediaLibrary" || @externalProcessing
      @dispatcher.trigger("s3UploadComplete", upload)
    else
      @processUpload(upload)

  s3UploadStart: (e, upload) ->
    upload.assetableId = @assetableId
    upload.assetableType = @assetableType
    upload.assetType = @assetType
    upload.requirementsAsset = @isRequirementsAsset
    upload.relationship = @relationship

    @dispatcher.trigger("assetProcessing", upload)
    @dispatcher.trigger("s3UploadStart", upload)

  processUpload: (upload) ->
    $.ajax
      url: "/media/s3_upload",
      type: 'POST',
      dataType: 'json',
      data:
        data_remote_url: upload.url
      success: (data) =>
        options =
          upload: upload
          asset: data
          assetableId: data.assetable_id || upload.assetableId
          assetableType: data.assetable_type || upload.assetableType
          assetType: data.assetType || upload.assetType
        @dispatcher.trigger("assetProcessingComplete", options)



// WEBPACK FOOTER //
// ./app/javascript/backbone/shared/views/s3_uploader_view.js.coffee